// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3ux4h","loaderOuter":"PageOverlayLoader_loaderOuter__1oLet"};